import * as reportsReducer from '../../redux/modules/reports';
import * as authActions from "../../redux/modules/auth";

const mapStateToProps = state => ({
  reportsData: state.reports && state.reports.reportsData,
  requestStats: state.travelExpense.requestStats,
  language: state.auth.language,
  isActive: state.auth.isActive,

});

const mapDispatchToProps = {
  ...reportsReducer,
  ...authActions,
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/reports/index.js